import { useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useLineContext } from '../hooks/useLineContext';
import { useAppStore } from '../stores/appStore';
import { useDialogStore } from '../stores/dialogStore';
import { useUserStore } from '../stores/userStore';
import StarCardLoading from './feedback/StarCardLoading';

const ProtectedRoute = ({ allowedRoles, children }) => {
  const userInfo = useUserStore((state) => state.userInfo);
  const appLoading = useAppStore((state) => state.appLoading);
  const openDialog = useDialogStore((state) => state.openDialog);
  const { lineProfile } = useLineContext();
  const hasShownDialog = useRef(false);

  const userRole = userInfo?.role_id?.name;
  const isAllowed = allowedRoles.includes(userRole);

  useEffect(() => {
    if (!appLoading && userInfo && !isAllowed && !hasShownDialog.current) {
      hasShownDialog.current = true;
      openDialog({
        title: 'ไม่มีสิทธิ์เข้าถึง',
        message: `คุณไม่มีสิทธิ์เข้าถึงหน้านี้\nUserId: ${lineProfile?.userId ?? '-'}`,
        variant: 'error',
      });
    }
  }, [appLoading, userInfo, isAllowed, openDialog, lineProfile?.userId]);

  if (appLoading) {
    return <StarCardLoading />;
  }

  if (!userInfo) {
    return <Navigate to="/" replace />;
  }

  if (!isAllowed) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default ProtectedRoute;
